if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // Kratek timeout za iOS Safari, ki potrebuje čas za DOM inicializacijo
      setTimeout(() => this.loadRecommendations(), 0);
    }

    loadRecommendations() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error('Product recommendations error:', e);
        });
    }
  });
}
